import * as XLSX from 'xlsx';
import { triggerDownload, today } from './downloadHelpers';

const CSV_HEADERS = ['Fecha', 'Tipo de Documento', 'Emisor NIT', 'Emisor', 'Receptor NIT', 'Receptor', 'Gravadas', 'IVA', 'Total a Pagar', 'Número de Control', 'Código de Generación'];

function toRow(inv) {
  return [
    inv.date,
    inv.tipoDteLabel,
    inv.issuer.nit,
    inv.issuer.name,
    inv.receiver.nit,
    inv.receiver.name,
    inv.totals.gravadas,
    inv.totals.iva,
    inv.totals.totalPagar,
    inv.controlNumber,
    inv.generationCode,
  ];
}

export function exportElSalvadorCsv(invoices) {
  const rows = invoices.map(inv => toRow(inv).map(v => (typeof v === 'number' ? v.toFixed(2) : v)));
  const csv = [CSV_HEADERS, ...rows]
    .map(row => row.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
    .join('\n');
  triggerDownload(
    new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' }),
    `dte_sv_${today()}.csv`
  );
}

export function exportElSalvadorExcel(invoices) {
  const wb = XLSX.utils.book_new();

  const summaryRows = [CSV_HEADERS, ...invoices.map(toRow)];
  const ws1 = XLSX.utils.aoa_to_sheet(summaryRows);
  ws1['!cols'] = [12, 28, 14, 32, 14, 32, 12, 12, 14, 24, 40].map(w => ({ wch: w }));
  XLSX.utils.book_append_sheet(wb, ws1, 'DTE');

  const itemRows = [
    ['Código de Generación', 'Fecha', 'Emisor', 'N° Ítem', 'Cantidad', 'Descripción', 'Precio Unitario', 'Venta Gravada'],
    ...invoices.flatMap(inv =>
      (inv.items || []).map(item => [
        inv.generationCode, inv.date, inv.issuer.name,
        item.numItem, item.quantity, item.description,
        item.unitPrice, item.taxedAmount,
      ])
    ),
  ];
  const ws2 = XLSX.utils.aoa_to_sheet(itemRows);
  ws2['!cols'] = [40, 12, 32, 8, 10, 50, 16, 16].map(w => ({ wch: w }));
  XLSX.utils.book_append_sheet(wb, ws2, 'Detalle Líneas');

  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  triggerDownload(
    new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
    `dte_sv_${today()}.xlsx`
  );
}
